import type { PurchaseOrder, RestaurantVendor, SupplyItem } from './types';

/** A preference suggests an order destination; it is not a priced vendor catalog entry. */
export function commonPreferredVendorId(items: readonly SupplyItem[], vendors: readonly RestaurantVendor[]): string {
  if (!items.length || items.some((item) => !item.active)) return '';
  const preferredVendorId = items[0].preferredVendorId;
  if (!preferredVendorId || items.some((item) => item.preferredVendorId !== preferredVendorId || item.restaurantId !== items[0].restaurantId)) return '';
  return vendors.some((vendor) => vendor.id === preferredVendorId && vendor.active && vendor.restaurantId === items[0].restaurantId)
    ? preferredVendorId : '';
}

/** Saved orders must never acquire a different brand after an inventory edit. */
export function purchaseLineBrand(line: PurchaseOrder['lines'][number]): string {
  return line.brand?.trim() || '';
}

/** Use one package definition for both draft labels and package-to-base input conversion. */
export function purchasePackagePresentation(item: SupplyItem, vendor?: RestaurantVendor) {
  const catalogItem = vendor?.active && vendor.restaurantId === item.restaurantId
    ? vendor.catalog.find((entry) => entry.itemId === item.id) : undefined;
  return {
    purchaseUnit: catalogItem?.purchaseUnit || item.purchaseUnit,
    quantityPerPackage: catalogItem?.quantityPerPackage || item.quantityPerPackage || 1,
  };
}

export function preferredSuppliesForVendor(vendor: RestaurantVendor, items: readonly SupplyItem[]): SupplyItem[] {
  return items.filter((item) => item.active && item.restaurantId === vendor.restaurantId && item.preferredVendorId === vendor.id);
}

/** Count an item only once when it has both a contact preference and a priced catalog entry. */
export function linkedSupplyCount(vendor: RestaurantVendor, items: readonly SupplyItem[]): number {
  return new Set([...vendor.catalog.map((entry) => entry.itemId), ...preferredSuppliesForVendor(vendor, items).map((item) => item.id)]).size;
}
